import { v4 as uuidv4 } from 'uuid';
import DataHelper from '../helpers/DataHelper.js';

export default class Context {
  constructor() {
    this.schema = `iglu:${this.host}/${this.key}/jsonschema/${this.version}`;
    this.data = {};
  }

  static get key() {
    throw Error('Key getter is undefined');
  }

  static get version() {
    return '1-0-0';
  }

  static get host() {
    return 'uk.co.netdirector.snowplow';
  }

  static import(data) {
    const context = new this();
    if (context.schema !== data.schema) {
      throw Error('Cannot import context from JSON');
    }
    context.update(data.data);
    return context;
  }

  static importFromJSON(json) {
    this.import(JSON.parse(json));
  }

  get key() {
    return this.constructor.key;
  }

  get version() {
    return this.constructor.version;
  }

  get host() {
    return this.constructor.host;
  }

  export() {
    return {
      schema: this.schema,
      data: this._filterData(DataHelper.cloneData(this.data))
    };
  }

  exportToJSON() {
    return JSON.stringify(this.export());
  }

  _filterData(data) {
    return DataHelper.filterDeeply(data);
  }

  update(data) {
    Object.assign(this.data, data);
  }

  generateUuid() {
    return uuidv4();
  }
}
